import { render, staticRenderFns } from "./ModalEditPlan.vue?vue&type=template&id=22f32d84"
import script from "./ModalEditPlan.vue?vue&type=script&lang=js"
export * from "./ModalEditPlan.vue?vue&type=script&lang=js"
import style0 from "./ModalEditPlan.vue?vue&type=style&index=0&id=22f32d84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports